import { render } from "./DummyInterview.vue?vue&type=template&id=dc428180"
import script from "./DummyInterview.vue?vue&type=script&lang=js"
export * from "./DummyInterview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__